/**
 * Provide convenient API for Prime Launcher.
 * Use abstract data provider for data retrieving and handle it for Prime Launcher purposes.
 *
 * @module launcher.api.provider
 */

'use strict';

var RESOLUTION   = screen.height,
    uniqueItemID = 1,
    intentContext,
    index;


/**
 * Play karaoke track via sending intent.
 *
 * @param {Object[]} allTracksQueue - all retrieved karaoke tracks to play
 * @param {Object} item - resource to open
 */
function playKaraokeTrack ( allTracksQueue, item ) {
    var intentData = {
        action: 'play',
        mime: 'content/video',
        data: {
            uri:      item.url,
            title:    item.name,
            solution: item.solution || 'auto',
            mediaId:  item.id
        },
        context: intentContext,
        events: {
            error: function () {
                intentContext = null;
            },
            hide: function () {
                intentContext = null;
            },
            close: function () {
                intentContext = null;
            },
            prev: function () {
                index = allTracksQueue.indexOf(item);

                playKaraokeTrack(allTracksQueue, allTracksQueue[--index % allTracksQueue.length]);
            },
            next: function () {
                index = allTracksQueue.indexOf(item);

                playKaraokeTrack(allTracksQueue, allTracksQueue[++index % allTracksQueue.length]);
            }
        }
    };

    // delete intent events depending on file position in queue, disable "prev" on the first one and "next" on the last
    if ( !index ) {
        delete intentData.events.prev;
    }

    if ( index === allTracksQueue.length - 1 ) {
        delete intentData.events.next;
    }

    core.intent(intentData, function ( error, context ) {
        if ( !error ) {
            intentContext = context;
        }
    });
}


module.exports = function ( config, callback ) {
    var gettextWrapper = require('mag-gettext');

    gettextWrapper.load({
        name: core.environment.language,
        path: config.path + 'lang'
    }, function () {
        var dataProvider    = require('./data.provider'),
            Emitter         = require('cjs-emitter'),
            _               = gettextWrapper.gettext,
            contentProvider = new Emitter(),
            launcherAPI     = config.api,
            layout          = launcherAPI.layouts.static,
            geometry        = launcherAPI.geometry.square,
            setup           = {
                // how many tracks send to Prime Launcher (max)
                tracksAmount: 10,
                moreButton: {
                    id:       ++uniqueItemID,
                    layout:   layout,
                    geometry: geometry,
                    data: {
                        name: _('See more'),
                        icon: {
                            normal: config.path + 'img/' + RESOLUTION + '/see.more.normal.png',
                            active: config.path + 'img/' + RESOLUTION + '/see.more.active.png'
                        }
                    },
                    runApp: true
                    /*onClick: function () {
                        core.intent({
                            action: 'karaoke:open',
                            events: {}
                        }, function ( error ) {
                            if ( error ) {
                                console.log(error);
                            }
                        });
                    }*/
                }
            };


        /**
         * Content search.
         *
         * @param {Object} config - configuration for search
         * @param {string} config.query - query search request
         * @param {Function} callback - which called when content is ready
         */
        contentProvider.search = function ( config, callback ) { // eslint-disable-line
            // @TODO: query data and invoke `callback(error, ContentItem[]);`
        };


        // collect data for Leanback Launcher on start
        dataProvider.getTracks({favorite: false}, function ( error, result ) {
            var tracks;

            if ( error ) {
                /*--------------------------
                 Here and in all such cases... if first argument (error) is object (or something truthy) it's the signal
                 to Leanback Launcher to supress plugin output, even content string doesn't show
                --------------------------*/

                callback(error);
            } else {
                try {
                    if ( Array.isArray(result.data) ) {
                        tracks = result.data
                            .map(function ( item ) {
                                return {
                                    id:       ++uniqueItemID,
                                    layout:   layout,
                                    geometry: geometry,
                                    data: {
                                        name:      item.name,
                                        /*performer: item.performer,
                                        url:       item.url,
                                        solution:  item.solution,
                                        id:        item.id,
                                        favorite:  item.favorite,*/
                                        icon: {
                                            normal: config.path + 'img/' + RESOLUTION + '/content.item.normal.png',
                                            active: config.path + 'img/' + RESOLUTION + '/content.item.active.png'
                                        }
                                    },
                                    onClick: function () {
                                        playKaraokeTrack(result.data, item);
                                    }
                                };
                            })
                            .sort(function ( track1, track2 ) {
                                if ( !track1.data.favorite && track2.data.favorite ) {
                                    return 1;
                                }

                                return -1;
                            })
                            .slice(0, setup.tracksAmount);

                        callback(null, {
                            provider: contentProvider,
                            data: tracks.length ? tracks.concat(setup.moreButton) : []
                        });
                    } else {
                        callback(true);
                    }
                } catch ( error ) {
                    callback(error);
                }
            }
        });
    });
};
